module.exports = {"id":"139368","name":"Jason Shackell","rating":"72","photo":"./data/images/photos/1/139368.png","club":{"name":"Millwall","logo":"./data/images/clubs/Millwall.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JasonShackell0.json
// module id = 1929
// module chunks = 0